import { Button, Modal, Spinner } from 'react-bootstrap';

interface ConfirmationModalProps {
  show: boolean;
  onHide: () => void;
  title?: string;
  bodyContent: React.ReactNode;
  footerButtonText?: string;
  onFooterButtonClick?: () => void;
  footerContent?: React.ReactNode;
  loading?: boolean;
}

const ConfirmationModal = ({
  show,
  onHide,
  title = 'Confirmation',
  bodyContent,
  footerButtonText = 'Close',
  onFooterButtonClick,
  loading = false
}: ConfirmationModalProps) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column align-items-center justify-content-center text-center">
        {bodyContent}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onFooterButtonClick || onHide} disabled={loading}>
          {loading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
              <span className="ms-2">Loading...</span>
            </>
          ) : (
            footerButtonText
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
